import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import { Button, Col, Row } from "react-bootstrap";
import "./completedJobDetails.scss";
import { useNavigate } from "react-router-dom";
import { fetchImage, getFullName, twoDecimalPlaces } from "../../utils/common";
import ReviewModal from "../../modals/review/ReviewModal";
import { StarOutline } from "../../components/Icons";
import UserImg from "../../../src/assets/images/providerProfileImg.png";
const CompletedJobDetails = ({ details, jobDetails }) => {
  const [reviewModal, setReviewModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState({});
  const [inlineItems, setInlineItems] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [startImage, setstartImage] = useState(null);
  const [inTransitImage, setInTransitImage] = useState(null);
  const [endImage, setEndImage] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    const handleImageFetch = async (imagePath, setImageFunction) => {
      if (imagePath) {
        try {
          const fetchedImage = await fetchImage(imagePath);
          setImageFunction(fetchedImage);
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      }
    };

    const fetchData = async () => {
      if (jobDetails?.lineItemsData) {
        setInlineItems(convertToKeyValuePairs(jobDetails.lineItemsData));
      }

      await handleImageFetch(
        jobDetails?.providerId?.profilePic,
        setProfileImage
      );
      await handleImageFetch(jobDetails?.startSelfie, setstartImage);
      await handleImageFetch(jobDetails?.inTransitSelfie, setInTransitImage);
      await handleImageFetch(jobDetails?.endSelfie, setEndImage);

      if (!jobDetails?.providerId?.profilePic) {
        setProfileImage(UserImg);
      }
    };

    fetchData();
  }, [jobDetails]); // Updated dependency array

  const handleReviewModal = (job) => {
    setSelectedJob(job);
    setReviewModal(true);
  };

  const getDuration = () => {
    if (jobDetails?.durationUpdated) {
      return `${twoDecimalPlaces(jobDetails?.durationUpdated)} Hr`;
    } else if (jobDetails?.durationExpected) {
      return `${twoDecimalPlaces(jobDetails?.durationExpected)} Hr`;
    } else {
      return "NA";
    }
  };
  function convertToKeyValuePairs(jsonString) {
    try {
      // Parse the JSON string into a JavaScript object
      const arrayOfObjects = JSON.parse(jsonString);

      // Check if the parsed data is an array
      if (!Array.isArray(arrayOfObjects)) {
        console.error("Input is not an array.");
        return [];
      }

      // Use map to transform each object into an array of key-value pairs
      return arrayOfObjects
        .map((obj) => {
          // Use Object.entries to get an array of [key, value] pairs for each object
          const keyValuePairs = Object.entries(obj);

          // Use map again to transform each [key, value] pair
          const mappedPairs = keyValuePairs.map(([key, value]) => {
            // Here, you can modify or process the key and value as needed
            return { key, value };
          });

          // Return the modified object
          return mappedPairs;
        })
        .flat(); // Use flat to flatten the array of arrays
    } catch (error) {
      console.error("Error parsing JSON:", error.message);
      return [];
    }
  }

  return (
    <>
      <Header />
      <PageHeading title="Job Details" />
      <div className="main-container">
        <div className="completed-job-wrapper">
          <div className="completed-job-content-wrapper">
            <div className="completed-job-section">
              <div className="box-wrapper completed-job-content">
                <div className="job-user-detail-wrap">
                  <div className="job-user-pic">
                    <img src={profileImage} alt="User" />
                  </div>
                  <div className="job-user-detail">
                    <div className="job-user-name">
                      {getFullName(
                        jobDetails?.providerId?.firstName,
                        jobDetails?.providerId?.lastName
                      )}
                    </div>
                    <div className="rating-wrap">
                      <div className="rating">
                        <StarOutline /> <StarOutline /> <StarOutline />
                        <StarOutline /> <StarOutline />
                      </div>
                      <div className="rating-value">
                        ({jobDetails?.providerId?.ratingProvider || 0})
                      </div>
                    </div>
                  </div>
                </div>
                <div className="job-descreption">{jobDetails?.jobDetail}</div>
              </div>
            </div>
            <div className="completed-job-section">
              <div className="completed-job-title">Payment Detail</div>
              <div className="payment-detail-wrap">
                <table className="table">
                  <tr>
                    <td>Time</td>
                    <td>{getDuration()}</td>
                  </tr>
                  <tr>
                    <td width="800">Charges</td>
                    <td width="140">
                      ${twoDecimalPlaces(jobDetails?.calculatedPrice)}
                    </td>
                  </tr>
                  {inlineItems?.length > 0 ? (
                    <>
                      <tr>
                        <td width="800">
                          Additional Charges(Additional Charges already included
                          in Charges)
                        </td>
                        <td width="140"></td>
                      </tr>

                      {inlineItems?.map((item, index) => (
                        <tr key={index}>
                          <td width="800">{item?.key}</td>
                          <td width="140">${item?.value}</td>
                        </tr>
                      ))}
                    </>
                  ) : null}

                  <tr>
                    <td>Helpr app fee & Transaction fee</td>
                    <td>${twoDecimalPlaces(jobDetails?.taxAmount)}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>${twoDecimalPlaces(jobDetails?.finalPrice)}</td>
                  </tr>

                  {jobDetails?.couponCode && (
                    <>
                      <tr>
                        <td>Dicscount ({jobDetails?.couponCode})</td>
                        <td>
                          <div>${jobDetails?.couponDiscount}</div>
                        </td>
                      </tr>
                      <tr>
                        <td>New Total</td>
                        <td>
                          <div>${ twoDecimalPlaces(jobDetails?.finalPriceAfterDiscount)}</div>
                        </td>
                      </tr>
                    </>
                  )}
                </table>
              </div>
            </div>
            {jobDetails?.startSelfie ||
            jobDetails?.inTransitSelfie ||
            jobDetails?.endSelfie ? (
              <div className="completed-job-section">
                <Row>
                  {jobDetails?.startSelfie ? (
                    <Col sm={6} className="pb-4 pb-sm-0">
                      <div className="completed-job-title pb-3">
                        Start Job Selfie
                      </div>
                      <div className="job-selfie-img-wrap">
                        {" "}
                        <img src={startImage} alt="" />
                      </div>
                    </Col>
                  ) : null}
                  {jobDetails?.inTransitSelfie ? (
                    <Col sm={6}>
                      <div className="completed-job-title pb-3">
                        In transit Job Selfie
                      </div>
                      <div className="job-selfie-img-wrap">
                        <img src={inTransitImage} alt="" />
                      </div>
                    </Col>
                  ) : null}
                  {jobDetails?.endSelfie ? (
                    <Col sm={6}>
                      <div className="completed-job-title pb-3">
                        End Job Selfie
                      </div>
                      <div className="job-selfie-img-wrap">
                        <img src={endImage} alt="" />
                      </div>
                    </Col>
                  ) : null}
                </Row>
              </div>
            ) : null}

            <div className="box-wrapper delivery-details-wrap">
              <div className="delivery-details">
                <div className="delivery-details-title">Pickup Details</div>
                <div className="delivery-user-name">
                  {getFullName(
                    jobDetails?.sender?.firstName,
                    jobDetails?.sender?.lastName
                  )}
                </div>
                <div className="delivery-user-address">
                  {jobDetails?.sender?.address}
                </div>
                <div className="delivery-user-phone">
                  {jobDetails?.sender?.phone}
                </div>
              </div>
              <div className="delivery-details-divider"></div>
              <div className="delivery-details">
                <div className="delivery-details-title">Delivery Details</div>

                <div className="delivery-user-name">
                  {getFullName(
                    jobDetails?.receiver?.firstName,
                    jobDetails?.receiver?.lastName
                  )}
                </div>
                <div className="delivery-user-address">
                  {jobDetails?.receiver?.address}
                </div>
                <div className="delivery-user-phone">
                  {jobDetails?.receiver?.phone}
                </div>
              </div>
            </div>
          </div>

          <div className="w-100 d-flex gap-3 d-grid flex-column">
            {jobDetails?.ratedByUser ? (
              <Button
                variant="outline-primary"
                onClick={() => handleReviewModal(jobDetails)}
              >
                Add Review
              </Button>
            ) : null}
            {/* <Button variant='primary'>Pay Now</Button> */}
          </div>
        </div>
      </div>
      <Footer />

      {reviewModal ? (
        <ReviewModal
          userType="user"
          job={selectedJob}
          handleReviewSuccess={() => navigate(-1)}
          setReviewModal={setReviewModal}
          reviewModal={reviewModal}
        />
      ) : null}
    </>
  );
};

export default CompletedJobDetails;
